<template>
  <el-submenu v-if="menu.children" :index="menu.path" :path="menu.path">
    <template slot="title">
      <item v-if="menu.title" :icon="menu.icon" :title="menu.title" />
    </template>
    <MenuItem v-for="childMenu in menu.children" :menu="childMenu" :key="childMenu.path"></MenuItem>
  </el-submenu>
  <el-menu-item v-else :index="menu.path" :path="menu.path">
    <item v-if="menu.title" :icon="menu.icon" :title="menu.title" />
  </el-menu-item>
</template>
<script>
import MenuItem from "./MenuItem.vue";
import Item from "./Item.vue";
export default {
  name: "MenuItem",
  props: ["menu"],
  components: { MenuItem, Item },
  data() {
    return {};
  },
  computed: {
    hasChildren() {
      return this.menu.children && this.menu.children.length;
    },
  },
  methods: {
    menuClick() {
      this.$emit("menuClick", this.menu.path);
    },
    childMenuLick(path) {
      this.$emit("menuClick", path);
    },
  },
};
</script>
<style lang="less" scoped>
.menu-item {
  .menu_content {
    display: flex;
    cursor: pointer;
    &.active {
      color: #1890ff;
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
